module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "l-container"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "padding": "4.5px 0"
    }
  }, [_c('h1', {
    staticClass: "m-name"
  }, [_vm._v(_vm._s(_vm.tutor.id) + " " + _vm._s(_vm.tutor.f_name) + " " + _vm._s(_vm.tutor.l_name) + " ( " + _vm._s(_vm.tutor.f_name_kana) + " " + _vm._s(_vm.tutor.l_name_kana) + " ) 様")]), _vm._v(" "), _c('div', {
    staticClass: "mediumForm"
  }, [_c('ul', _vm._l((_vm.tutor.tutor_channels), function(list, index) {
    return _c('li', {
      key: index,
      staticClass: "medium-list"
    }, [(list.channel) ? [_c('span', [_vm._v(_vm._s(list.channel.name))])] : _vm._e()], 2)
  }), 0)])]), _vm._v(" "), _c('router-view', {
    attrs: {
      "tutor": _vm.tutor,
      "condition": _vm.condition,
      "edit_id": _vm.edit_id
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09da318e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Tutor/Tutor2.vue
// module id = 1284
// module chunks = 0